import { Component, Input, OnInit } from '@angular/core';
import { FormHelper } from '@helpers/form.helper';
import { enumEntityModelCode } from '@data-layer/enums/entities';
import { EntityModel } from '@data-layer/models/entities';
import { EntityValidationHelper } from '@helpers/entity-validation.helper';

@Component({
  selector: 'card-step-body',
  templateUrl: './card-step-body.component.html',
  styleUrls: ['./card-step-body.component.scss'],
})
export class CardStepBodyComponent implements OnInit {
  @Input() public isfEntity: EntityModel;
  @Input() public isShowIdentifierBlock = true;

  public enumEntityModelCode: typeof enumEntityModelCode = enumEntityModelCode;

  constructor(private fh: FormHelper) {}

  public ngOnInit(): void {}

  public getValidationText(isfEntity: EntityModel, field: string) {
    return EntityValidationHelper.entityGetSummaryValidationText(isfEntity, field);
  }

  public isValidIsfEntityAddress(): boolean {
    return this.fh.isValidIsfEntityAddress(this.isfEntity.address);
  }
}
